<template>
  <div class="text-secondary text-medium-1 text-center thin">
    &quot;<span class="text-medium-1 text-secondary">{{ quote.title }}</span
    >&quot; -
    {{ quote.author }}
  </div>
</template>

<script>
const quotes = [
  {
    title: 'The man who moves a mountain begins by carrying away small stones',
    author: 'Confucius'
  },
  {
    title:
      'The trouble with not having a goal is that you can spend your life running up and down the field and never score',
    author: 'Bill Copeland'
  },
  {
    title: "Shoot for the moon. Even if you miss, you'll land among the stars",
    author: 'Les Brown'
  },
  {
    title:
      'The great danger for most of us lies not in setting our aim too high and falling short; but in setting our aim too low, and achieving our mark',
    author: 'Michelangelo'
  },
  {
    title: 'Obstacles are those frightful things you see when you take your eyes off your goal',
    author: 'Henry Ford'
  },
  {
    title: 'If a man knows not which port he sails, no wind is favorable.',
    author: 'Seneca the Younger'
  }
]

const randomBetween = (min, max) => Math.floor(min + Math.random() * (max - min + 1))

/*
This component renders quote at random.
 */
export default {
  name: 'Quote',
  data() {
    let quoteIndex = randomBetween(0, quotes.length - 1)
    return {
      quote: quotes[quoteIndex]
    }
  }
}
</script>

<style lang="scss" scoped></style>
